import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  ADD_BUTTON_SIZE,
  HEADER_HEIGHT,
  TABLE_HEADER,
  TEXT_OVERFLOW_2LINES,
} from '../../_constants/styleConst';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import {
  GetTemplate,
  GetTemplateItemMaster,
  GetTemplateCompanyMaster,
} from '../../services/apiTypes';
import CreateTemplateModal from './components/CreateTemplateModal';
import ConfirmModal from '../../_common/Modal/ConfirmModal';
import {
  INSPECTION_CLASS,
  INSPEX_PATHNAME,
  ROWS_PER_PAGE_LIST,
  TEMPLATE_CLASS,
} from '../../_constants/Const';
import AddButton from '../../_common/Button/AddButton';
import useErrorModal from '../../hooks/useErrorModal';
import ErrorModal from '../../_common/Modal/ErrorModal';
import {
  isGetReportFormat,
  isGetTemplateItemMaster,
  isGetTemplateMaster,
} from '../../_utils/typeGuardUtils';
import EditTemplateModal from './components/EditTemplateModal';
import { getReportFormat } from '../../services/api/reportFormat';
import {
  countTableRows,
  getMidIndex,
  createReportFormatTable,
} from '../../_utils/inspectionUtils';
import { AppDispatch, RootState } from '../../stores/store';
import { useDispatch, useSelector } from 'react-redux';
import { API_CODE } from '../../_constants/apiConst';
import { useNavigate } from 'react-router-dom';
import TemplateItemModal from './components/TemplateItemModal';
import TemplateCompanyModal from './components/TemplateCompanyModal';
import { NavigateReportFormat } from '../../types/NavigateOptionType';
import { formatDate } from '../../_utils/utils';
import {
  deleteTemplateMaster,
  getTemplateMaster,
} from '../../stores/template/slice';
import { getTemplateItemMaster } from '../../stores/templateItem/slice';
import { isRejected } from '@reduxjs/toolkit';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BusinessIcon from '@mui/icons-material/Business';

const defaultTemplate: GetTemplate = {
  templateId: 0,
  inspectionClass: 1,
  templateClass: 1,
  documentNo: '',
  effectiveDate: '',
  isReadOnly: false,
  displayName: '',
  templateName: '',
  templateNameJp: '',
  templateName03: '',
  templateName04: '',
  templateName05: '',
  templateName06: '',
  templateName07: '',
  templateName08: '',
  templateName09: '',
  templateName10: '',
  selectedCompanyList: [],
};

const previewDataDefault: NavigateReportFormat = {
  title: '',
  documentNo: '',
  effectiveDate: '',
  formatTables: [],
};

const tableHeader = [
  {
    p: '1.5rem 0.5rem',
    width: '5%',
    minWidth: '30px',
    label: 'LBL_ID',
    textAlign: 'center',
  },
  {
    p: '0.5rem',
    width: '18%',
    minWidth: '150px',
    label: 'LBL_TEMPLATE_NAME',
    textAlign: 'left',
  },
  {
    p: '0.5rem',
    width: '8%',
    minWidth: '125px',
    label: 'LBL_INSPECTION_CLASS',
    textAlign: 'center',
  },
  {
    p: '0.5rem',
    width: '15%',
    minWidth: '130px',
    label: 'LBL_TEMPLATE_CLASS',
    textAlign: 'center',
  },
  {
    p: '0.5rem',
    width: '8%',
    minWidth: '140px',
    label: 'LBL_DOCUMENT_NO',
    textAlign: 'left',
  },
  {
    p: '0.5rem',
    width: '8%',
    minWidth: '110px',
    label: 'LBL_EFFECTIVE_DATE',
    textAlign: 'center',
  },
  {
    p: '0.5rem',
    width: '12%',
    minWidth: '140px',
    label: 'LBL_PREVIEW',
    textAlign: 'center',
  },
  {
    p: '0.5rem',
    width: '7%',
    minWidth: '110px',
    label: 'LBL_INSPECTION_ITEM_SETTING',
    textAlign: 'center',
  },
  {
    p: '0.5rem',
    width: '7%',
    minWidth: '110px',
    label: 'LBL_COMPANY_SETTING',
    textAlign: 'center',
  },
  {
    p: '0',
    width: '6%',
    minWidth: '30px',
    label: 'LBL_EDIT',
    textAlign: 'center',
  },
  {
    p: '0',
    width: '6%',
    minWidth: '30px',
    label: 'LBL_DELETE',
    textAlign: 'center',
  },
];

const ManageTemplate: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { error, showApiError, showTypeError, hideError } = useErrorModal();
  const { userData } = useSelector((state: RootState) => state.userInfo);
  /** テンプレート一覧 */
  const [templateList, setTemplateList] = useState<GetTemplate[]>([]);
  /** 選択可能なカンパニー一覧 */
  const [companyList, setCompanyList] = useState<GetTemplateCompanyMaster[]>(
    [],
  );
  /** 選択中のテンプレート項目一覧 */
  const [templateItemMaster, setTemplateItemMaster] =
    useState<GetTemplateItemMaster>([]);
  /** 選択中のテンプレート */
  const [targetTemplate, setTargetTemplate] =
    useState<GetTemplate>(defaultTemplate);
  /** テンプレート作成ダイアログの開閉フラグ */
  const [isOpenCreateModal, setIsOpenCreateModal] = useState(false);
  /** テンプレート編集ダイアログの開閉フラグ */
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  /** テンプレート削除ダイアログの開閉フラグ */
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  /** テンプレート項目ダイアログの開閉フラグ */
  const [isOpenItemModal, setIsOpenItemModal] = useState(false);
  /** テンプレート組織ダイアログの開閉フラグ */
  const [isOpenCompanyModal, setIsOpenCompanyModal] = useState(false);
  /** 表示するページ */
  const [page, setPage] = useState(0);
  /** 1ページに表示する行数 */
  const [rowsPerPage, setRowsPerPage] = useState(ROWS_PER_PAGE_LIST[0]);

  useEffect(() => {
    getAllTemplate();
  }, []);

  const handleChangePage = (
    _: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  /** テンプレート一覧取得 */
  const getAllTemplate = async () => {
    const response = await dispatch(getTemplateMaster());
    if (isRejected(response)) {
      showApiError(response.payload, API_CODE.TEMPLATE_MASTER);
      return;
    }
    if (!isGetTemplateMaster(response.payload)) {
      showTypeError(API_CODE.TEMPLATE_MASTER);
      return;
    }
    setTemplateList(response.payload.templateList);
    setCompanyList(response.payload.companyMasterList);
    setPage(0);
  };

  /** プレビューボタン押下 */
  const onClickPreview = async (templateId: number, templateName: string) => {
    const previewData: NavigateReportFormat = previewDataDefault;

    // プレビューぺージに渡したいもの
    try {
      const response = await getReportFormat({ templateId });
      if (isGetReportFormat(response)) {
        // 帳票形式にする
        const reportTableAll = createReportFormatTable(response);
        const tableRowList = countTableRows(reportTableAll);
        const midIndex = getMidIndex(tableRowList);
        previewData.formatTables = [
          reportTableAll.slice(0, midIndex),
          reportTableAll.slice(midIndex),
        ];
        // PDF保存時のファイル名用にtitleを変更する
        previewData.title = response.documentNo + '_' + templateName + '.pdf';
        previewData.documentNo = response.documentNo;
        previewData.effectiveDate = formatDate(
          response.effectiveDate,
          userData.dateFormat,
        );
      } else {
        showTypeError(API_CODE.REPORT_FORMAT);
        return;
      }
    } catch (error) {
      showApiError(error, API_CODE.REPORT_FORMAT);
      return;
    }
    navigate(INSPEX_PATHNAME.REPORT_FORMAT, {
      state: previewData as NavigateReportFormat,
    });
  };

  /** 診断項目設定ボタン押下 */
  const onClickTemplateItem = async (template: GetTemplate) => {
    const response = await dispatch(
      getTemplateItemMaster({ templateId: template.templateId }),
    );
    if (isRejected(response)) {
      showApiError(response.payload, API_CODE.TEMPLATE_ITEM_MASTER);
      return;
    }
    if (!isGetTemplateItemMaster(response.payload)) {
      showTypeError(API_CODE.TEMPLATE_ITEM_MASTER);
      return;
    }
    setTargetTemplate(template);
    setTemplateItemMaster(response.payload);
    setIsOpenItemModal(true);
  };

  /** 診断項目設定ダイアログを閉じる */
  const handleCloseItemModal = (isSave: boolean) => {
    setIsOpenItemModal(false);
    setTemplateItemMaster([]);
    // 保存後に編集ダイアログを開く
    if (isSave) {
      onClickEdit(targetTemplate);
    }
  };

  /** 組織設定ボタン押下 */
  const onClickTemplateCompany = (template: GetTemplate) => {
    setTargetTemplate(template);
    setIsOpenCompanyModal(true);
  };

  /** 組織設定ダイアログを閉じる */
  const handleCloseCompanyModal = (isSave: boolean) => {
    setIsOpenCompanyModal(false);
    if (isSave) {
      getAllTemplate();
    }
  };

  /** 編集ボタン押下 */
  const onClickEdit = (template: GetTemplate) => {
    setTargetTemplate(template);
    setIsOpenEditModal(true);
  };

  /** 編集ダイアログを閉じる */
  const handleCloseEditModal = (isSave: boolean) => {
    setIsOpenEditModal(false);
    if (isSave) {
      getAllTemplate();
    }
  };

  /** 削除ボタン押下 */
  const onClickDelete = (template: GetTemplate) => {
    setTargetTemplate(template);
    setIsOpenDeleteModal(true);
  };

  /** 削除実行 */
  const executeDelete = async () => {
    setIsOpenDeleteModal(false);

    const response = await dispatch(
      deleteTemplateMaster({ templateId: targetTemplate.templateId }),
    );
    if (isRejected(response)) {
      showApiError(response.payload, API_CODE.TEMPLATE_MASTER);
      return;
    }

    getAllTemplate();
  };

  /** 作成ダイアログを閉じる */
  const handleCloseCreateModal = (isSave: boolean) => {
    setIsOpenCreateModal(false);
    if (isSave) {
      getAllTemplate();
    }
  };

  return (
    <Box
      sx={{
        mx: '2%',
        mt: `calc(${HEADER_HEIGHT} + 2rem)`,
        mb: `calc(${ADD_BUTTON_SIZE} * 1.5)`,
      }}
    >
      <TableContainer
        component={Paper}
        sx={{ width: '100%', margin: '1rem auto' }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {tableHeader.map(
                ({ p, width, minWidth, textAlign, label }, i) => (
                  <TableCell
                    key={`template_header${i}`}
                    sx={{
                      ...TABLE_HEADER,
                      p,
                      width,
                      minWidth,
                      textAlign,
                      cursor: 'default',
                    }}
                  >
                    {t(label)}
                  </TableCell>
                ),
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {templateList
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((template, i) => (
                <TableRow key={`template_master_${i}`}>
                  <TableCell
                    sx={{
                      p: tableHeader[0].p,
                      width: tableHeader[0].width,
                      minWidth: tableHeader[0].minWidth,
                      textAlign: tableHeader[0].textAlign,
                    }}
                  >
                    {template.templateId}
                  </TableCell>
                  <TableCell
                    sx={{
                      p: tableHeader[1].p,
                      width: tableHeader[1].width,
                      minWidth: tableHeader[1].minWidth,
                      textAlign: tableHeader[1].textAlign,
                    }}
                  >
                    <Typography sx={TEXT_OVERFLOW_2LINES}>
                      {template.displayName}
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      p: tableHeader[2].p,
                      width: tableHeader[2].width,
                      minWidth: tableHeader[2].minWidth,
                      textAlign: tableHeader[2].textAlign,
                    }}
                  >
                    {t(`${INSPECTION_CLASS[template.inspectionClass]}`)}
                  </TableCell>
                  <TableCell
                    sx={{
                      p: tableHeader[3].p,
                      width: tableHeader[3].width,
                      minWidth: tableHeader[3].minWidth,
                      textAlign: tableHeader[3].textAlign,
                    }}
                  >
                    {t(`${TEMPLATE_CLASS[template.templateClass]}`)}
                  </TableCell>
                  <TableCell
                    sx={{
                      p: tableHeader[4].p,
                      width: tableHeader[4].width,
                      minWidth: tableHeader[4].minWidth,
                      textAlign: tableHeader[4].textAlign,
                    }}
                  >
                    <Typography sx={{ whiteSpace: 'nowrap' }}>
                      {template.documentNo}
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      p: tableHeader[5].p,
                      width: tableHeader[5].width,
                      minWidth: tableHeader[5].minWidth,
                      textAlign: tableHeader[5].textAlign,
                    }}
                  >
                    {formatDate(template.effectiveDate, userData.dateFormat)}
                  </TableCell>
                  <TableCell
                    sx={{
                      p: tableHeader[8].p,
                      width: tableHeader[8].width,
                      minWidth: tableHeader[8].minWidth,
                      textAlign: tableHeader[8].textAlign,
                    }}
                  >
                    <Button
                      sx={{ width: '90%' }}
                      variant="outlined"
                      onClick={() =>
                        onClickPreview(
                          template.templateId,
                          template.templateName,
                        )
                      }
                    >
                      {t('BTN_PREVIEW')}
                    </Button>
                  </TableCell>
                  {/* テンプレート項目設定 */}
                  <TableCell
                    sx={{
                      p: tableHeader[6].p,
                      width: tableHeader[6].width,
                      minWidth: tableHeader[6].minWidth,
                      textAlign: tableHeader[6].textAlign,
                    }}
                  >
                    <Button onClick={() => onClickTemplateItem(template)}>
                      <AssignmentIcon sx={{ color: '#1E83BE' }} />
                    </Button>
                  </TableCell>
                  {/* 組織設定 */}
                  <TableCell
                    sx={{
                      p: tableHeader[7].p,
                      width: tableHeader[7].width,
                      minWidth: tableHeader[7].minWidth,
                      textAlign: tableHeader[7].textAlign,
                    }}
                  >
                    <Button onClick={() => onClickTemplateCompany(template)}>
                      <BusinessIcon sx={{ color: '#1E83BE' }} />
                    </Button>
                  </TableCell>

                  <TableCell
                    sx={{
                      p: tableHeader[9].p,
                      width: tableHeader[9].width,
                      minWidth: tableHeader[9].minWidth,
                      textAlign: tableHeader[9].textAlign,
                    }}
                  >
                    {!template.isReadOnly && (
                      <Button onClick={() => onClickEdit(template)}>
                        <EditIcon sx={{ color: 'gray' }} />
                      </Button>
                    )}
                  </TableCell>
                  <TableCell
                    sx={{
                      p: tableHeader[10].p,
                      width: tableHeader[10].width,
                      minWidth: tableHeader[10].minWidth,
                      textAlign: tableHeader[10].textAlign,
                    }}
                  >
                    {!template.isReadOnly && (
                      <Button onClick={() => onClickDelete(template)}>
                        <DeleteIcon color="error" />
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          labelRowsPerPage={t('LBL_ROWS_PER_PAGE')}
          rowsPerPageOptions={ROWS_PER_PAGE_LIST}
          component="div"
          count={templateList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) =>
            t('LBL_DISPLAY_DATA_LABEL', { 0: from, 1: to, 2: count })
          }
        />
      </TableContainer>
      <AddButton onClick={() => setIsOpenCreateModal(true)} />
      <TemplateItemModal
        isOpen={isOpenItemModal}
        templateId={targetTemplate.templateId}
        isReadOnly={targetTemplate.isReadOnly}
        templateItemMaster={templateItemMaster}
        handleClose={handleCloseItemModal}
      />
      <TemplateCompanyModal
        isOpen={isOpenCompanyModal}
        targetTemplate={targetTemplate}
        companyList={companyList}
        handleClose={handleCloseCompanyModal}
      />
      <CreateTemplateModal
        isOpen={isOpenCreateModal}
        handleClose={handleCloseCreateModal}
      />
      <EditTemplateModal
        isOpen={isOpenEditModal}
        targetTemplate={targetTemplate}
        handleClose={handleCloseEditModal}
      />
      <ConfirmModal
        isOpen={isOpenDeleteModal}
        displayMessage={t('MSG_DELETE_TEMPLATE')}
        onClickCancel={() => setIsOpenDeleteModal(false)}
        onClickOk={executeDelete}
      />
      {error && <ErrorModal message={error} onClose={hideError} />}
    </Box>
  );
};

export default ManageTemplate;
